module.exports = __webpack_public_path__ + "static/media/rawDeathsDataBackup.ec885a53.csv";